import { useExtensionData } from './extensionStorageListener'
import { ConcernTag, STORAGE_KEY } from '../utils/enums'

export const defaultUserConcerns: UserConcerns = {
  [ConcernTag.ACCOUNT_SECURITY]: 0.5,
  [ConcernTag.ACCOUNT_SEPARATION]: 0.5,
  [ConcernTag.CHILD_SAFETY]: 0.5,
  [ConcernTag.DATA_MISUSE]: 0.5,
  [ConcernTag.DIGITAL_WELLNESS]: 0.5,
  [ConcernTag.ONLINE_ABUSE]: 0.5,
  [ConcernTag.PHYSICAL_SAFETY]: 0.5,
}

export type UserConcerns = Partial<Record<ConcernTag, number>>

export default function useUserConcerns(): UserConcerns {
  const { data: rawData } = useExtensionData({
    local: [STORAGE_KEY.USER_CONCERNS],
  })

  const userConcerns: UserConcerns =
    rawData?.[STORAGE_KEY.USER_CONCERNS] || defaultUserConcerns

  return userConcerns
}
